import React from 'react';
import URL from '../../utils/constants';
import { useHistory } from 'react-router-dom';
import logoIntercorp from '../../assets/img/icons/logo_i.png';
import logoFacebook from '../../assets/img/icons/Facebook.svg';
import logoLinkedin from '../../assets/img/icons/Linkedin.svg';
import logoInstagram from '../../assets/img/icons/Instagram.svg';
import logoYoutube from '../../assets/img/icons/Youtube.svg';

export default function () {
  const history = useHistory();
  const param = localStorage.getItem('jwt');
  const goToPage = (url, ext) => ext ? window.open(url, '_blank') : window.location.replace(url);

  return (
    <>
      <footer>
        <div className='container-main'>
          <div className='d-flex justify-content-between footer__container pt-4 pb-4'>
            <div className='m-0 p-0 '>
              <div className='d-flex justify-content-between align-items-center' style={{ paddingBottom: '10px' }}>
                <div className='footer_text'>
                  <h5 className='text-white m-0 value-sans-pro-regular text-siguenos'>¡Síguenos para más novedades!</h5>
                </div>
                <div className='d-flex justify-content-start footer__social'>
                  <a
                    href='https://www.facebook.com/SomosIntercorp/'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <img
                      className='ml-2'
                      src={logoFacebook}
                      alt='Facebook'
                      style={{ height: '2rem' }}
                    />
                  </a>
                  <a
                    href='https://www.instagram.com/accounts/login/?next=/somosintercorp/'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <img
                      className='ml-2'
                      src={logoInstagram}
                      alt='Instagram'
                      style={{ height: '2rem' }}
                    />
                  </a>
                  <a
                    href='https://www.youtube.com/channel/UClpJfMwpGxpts0aH7_Kuosg'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <img
                      className='ml-2'
                      src={logoYoutube}
                      alt='Youtube'
                      style={{ height: '2rem' }}
                    />

                  </a>
                  <a
                    href='https://pe.linkedin.com/company/grupo-intercorp'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <img
                      className='ml-2'
                      src={logoLinkedin}
                      alt='Linkedin'
                      style={{ height: '2rem' }}
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className='d-flex align-items-center footer__logo p-0'>
              <p className='m-0 w-100 font-16 value-sans-pro-regular text-intercorp'> Co-creado desde Gestión del Talento Corporativo de Intercorp 2023</p>
              <img
                src={logoIntercorp}
                alt='Logo Intercorp'
                style={{ height: '2.2em', cursor: 'pointer', marginLeft: '1rem' }}
                onClick={(e) =>
                  param ? goToPage(URL.HOME, false) : history.push('/')
                }
              />
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
